module.exports = __webpack_public_path__ + "img/open-data-start-loading.800e65b2.gif";